// extracted by mini-css-extract-plugin
export default {"espacamento":"MoedaBancario_espacamento__KwuBj","label":"MoedaBancario_label__gtkob"};